export default function toggleInfoBox(close) {
    const infobox = document.querySelector(".infobox-container");        
    const infoboxFooter = document.querySelector(".infobox-footer");        
    const button = document.querySelector(".infobox-button");       
    const modal = document.getElementById('modal');    
    const horizontalLine = document.querySelector(".modal-line-horizontal");
    const verticalLine = document.querySelector(".modal-line-vertical"); 
    
    if (infobox.getAttribute("data-state") == "closed" && !close) {
        // close Modal
        if (modal.getAttribute("data-state") == "open") {
            modal.classList.add("hidden");
            setTimeout(() => {
                modal.classList.remove("hidden");
                modal.classList.remove("visible");
                horizontalLine.classList.remove("visible")
                verticalLine.classList.remove("visible")
            }, 150);
            modal.setAttribute("data-state", "closed")
        }
        infobox.classList.add("visible");
        infoboxFooter.classList.remove("hidden");
        button.classList.add("open");
        button.querySelector("span").innerHTML = "Hide";
        infobox.setAttribute("data-state", "open")

    } else {
        infobox.classList.add("hide");
        button.querySelector("span").innerHTML = "Exploring Data";
        infobox.setAttribute("data-state", "closed")

        clearTimeout(infoboxTimeout)

        setTimeout(() => {
            infobox.classList.remove("visible");
            button.classList.remove("open");
            infobox.classList.remove("hide");
        }, 300);
    }
}
 